import { Injectable } from '@angular/core';
import printJS from 'print-js';
import { isIEBrowser, isSafariBrowser, isAndroidChromeBrowser } from '../../utils/browser-helper';

@Injectable()
export class PrintService {
  private printInIEAndSafari(html: string) {
    const id = Math.floor(Math.random() * Math.pow(10, 13)).toString();
    const iframe = document.createElement('iframe');
    iframe.setAttribute('id', id);
    iframe.setAttribute('name', id);
    document.body.appendChild(iframe);
    const newWin = window.frames[id];
    newWin.document.write(`<body onload="window.print()">${html}</body>`);
    newWin.document.close();
    setTimeout(() => {
      iframe.remove();
    }, 1000);
  }

  printPDF(printable: string) {
    if (isIEBrowser() || isSafariBrowser() || isAndroidChromeBrowser()) {
      this.printInIEAndSafari(printable);

      return;
    }

    printJS({
      printable,
      type: 'pdf',
      base64: true,
    });
  }
}
